exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reactSelect-template-layout{width:270px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/pages/livefeed/Editor/TopMenuContainer/TemplateModal/index.less
// module id = 2237
// module chunks = 0